module.exports = __webpack_public_path__ + "img/tc2.0131a841.png";